import { client } from '../../utilities/config';
import { DONATION_STORES, SUBMIT_DONATION } from '../../../graphql/donations';

export const getDonationStores = () => client.query({
  query: DONATION_STORES,
  fetchPolicy: 'network-only',
});

export const submitDonation = (data, file) => {
  const fields = {
    contact_name: 'contactName', company_name: 'companyName', store: 'storeId',
    org_type: 'organizationDescription', n_501C3: 'isNonprofit', n_501c3_no: 'nonprofitNumber',
    event_type: 'eventType', event_location: 'eventLocation', event_location_2: 'eventLocationLine2',
    autocompleteLat: 'latitude', autocompleteLng: 'longitude', organization_promoting: 'promotion',
    event_date: 'eventDate', event_time: 'eventTime', expected_participants: 'expectedParticipants',
  };
  const input = {};
  Object.entries(data).forEach(([field, value]) => { input[fields[field] || field] = value; });
  return client.mutate({
    mutation: SUBMIT_DONATION,
    variables: { data: input, file },
  });
};
